import { database } from "..";
import { uuid } from "../../constants";
import { MODIFIER_OPTION_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";

const modifierOption = database.collections.get(MODIFIER_OPTION_SCHEMA);

const prepareInsertion = (modifier, modifierOptions) => {
  return modifierOptions.map((opt) => {
    return modifierOption.prepareCreate((obj) => {
      obj.modifier.set(modifier);

      obj._raw.id = opt.id;
      obj.name = opt.modifier_name;
      obj.price = opt.price;
      obj.in_stock = opt.isChecked;
      obj.created_at = new Date().getTime();
      obj.archive = false;
    });
  });
};

export const bulkCreateModifierOptions = async (modifier, modifierOptions) => {
  return await database.write(async () => {
    const allRecords = await prepareInsertion(modifier, modifierOptions);
    await database.batch(...allRecords);
    return allRecords;
  });
};
